import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import Header from "./Header";
import WelcomeOwl from "./WelcomeOwl";
import PersistentLiveRoom from "./PersistentLiveRoom";

// Modo enfoque: oculta menú lateral y header mientras el estudiante resuelve
// un cuestionario (no puede navegar fuera). #test-lock
const FOCUS_ROUTE_RE = /^\/estudiante\/cuestionario\/[^/]+/;

// Roles con consola corporativa (tipografía ejecutiva). El estudiante conserva
// la tipografía amigable.
const CORP_ROLES = ["admin", "docente", "franquiciado"];

export default function Layout() {
  const location = useLocation();
  const { user } = useAuth();
  const focusMode = FOCUS_ROUTE_RE.test(location.pathname);
  const corp = CORP_ROLES.includes(user?.role) ? "corp-console" : "";

  if (focusMode) {
    return (
      <div className={`min-h-screen jasq-surface ${corp}`} data-testid="app-layout-focus">
        <main className="min-h-screen overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    );
  }

  return (
    <div className={`min-h-screen flex jasq-surface ${corp}`} data-testid="app-layout">
      <div className="flex-1 flex flex-col min-w-0">
        <Header />
        <main className="flex-1 p-4 sm:p-6 md:p-8 lg:p-10 overflow-x-hidden">
          <Outlet />
        </main>
      </div>
      <WelcomeOwl />
      <PersistentLiveRoom />
    </div>
  );
}
